import React from "react";

const Tasks = () => {
  return (
    <React.Fragment>
      <h1>Tasks</h1>
    </React.Fragment>
  );
};

export default Tasks;
